import { jsxs as g, jsx as t } from "react/jsx-runtime";
import { forwardRef as R, useState as A } from "react";
import M from "@mui/material/Dialog";
import B from "@mui/material/DialogActions";
import N from "@mui/material/DialogContent";
import I from "@mui/material/DialogTitle";
import P from "@mui/material/useMediaQuery";
import a, { useTheme as j } from "styled-components";
import $ from "../../icons/close.js";
import F from "../../icons/collapse-center.js";
import E from "../../icons/enlarge.js";
import K from "../Button/Button.js";
import L from "../IconButton/IconButton.js";
const Q = {
  root: "dialogRoot",
  paper: "dialogPaper"
}, W = {
  root: "dialogTitleRoot"
}, q = {
  root: "dialogActionsRoot"
}, G = {
  root: "dialogContentRoot",
  dividers: "dialogContentDividers"
}, H = a(M).withConfig({
  displayName: "StyledDialog"
})([
  "&& .MuiBackdrop-root{background-color:rgba(0,0,0,0.3);}&&.dialogRoot .dialogPaper{width:",
  ";height:",
  ";max-height:",
  ";max-width:",
  ";background-color:",
  ";box-shadow:0 4px 20px 0 ",
  ";background-image:none;}"
], ({ $maximized: i }) => i ? "100%" : "", ({ $maximized: i }) => i ? "100%" : "", ({ $maximized: i }) => i ? "calc(100% - 64px)" : "", ({ $maximized: i }) => i ? "calc(100% - 64px)" : "", ({ theme: i }) => i.isLightTheme ? i.primaryBackground : i.secondaryBackground, ({ theme: i }) => i.primaryShadow), J = a(I).withConfig({
  displayName: "StyledDialogTitle"
})([
  "&&.dialogTitleRoot{min-height:48px;min-width:200px;display:flex;font-size:",
  ";line-height:1.2em;font-weight:",
  ";user-select:text;padding:8px 16px;align-items:center;box-sizing:border-box;border-bottom:1px solid ",
  ";}"
], ({ theme: i }) => i.typography.body500.fontSize, ({ theme: i }) => i.typography.fontWeightMedium, ({ theme: i }) => i.primaryBorder), O = a.div.withConfig({
  displayName: "TitlePanel"
})([
  "flex:1;padding:0px 10px;"
]), d = a(L).withConfig({
  displayName: "TitleAction"
})([
  "&&.iconButtonRoot{height:24px;width:24px;}& ~ &{margin-left:10px;}"
]), U = a(N).withConfig({
  displayName: "StyledDialogContent"
})([
  "&&.dialogContentRoot{color:",
  ";font-size:",
  ";line-height:1.5em;padding:16px;}&&.dialogContentDividers{border:none;}"
], ({ theme: i }) => i.text.primary, ({ theme: i }) => i.typography.body200.fontSize), V = a(B).withConfig({
  displayName: "StyledDialogActions"
})([
  "&&.dialogActionsRoot{padding:0px 16px 16px 16px;justify-content:flex-end;.buttonRoot + .buttonRoot{margin-left:16px;}}"
]), X = /* @__PURE__ */ R(({ children: i, disableBackdropClick: f = !0, showCross: u = !0, fullScreen: m = !1, onClose: e, onClosed: x, title: h, actions: l = null, TitlePanelComponent: y, showMaximize: b = !1, ...r }, C) => {
  const [c, p] = A(!1), D = j(), w = P(D.breakpoints.down("sm")), s = m === !0 ? m : w, z = () => Array.isArray(l) ? l.map((o, n) => {
    const v = typeof o.label == "string" ? o.label : n;
    return /* @__PURE__ */ t(K, {
      variant: o.variant,
      onClick: o.onClick,
      flavor: o.flavor,
      ...o.buttonProps,
      children: o.label
    }, v);
  }) : l, k = () => !b || s ? null : c ? /* @__PURE__ */ t(d, {
    "aria-label": "Maximize",
    onClick: () => p(!1),
    size: "small",
    variant: "normal",
    children: /* @__PURE__ */ t(F, {})
  }, "maximize") : /* @__PURE__ */ t(d, {
    "aria-label": "Minimize",
    onClick: () => p(!0),
    size: "small",
    variant: "normal",
    children: /* @__PURE__ */ t(E, {})
  }, "minimize"), S = (o, n) => {
    (!f || n !== "backdropClick") && (e == null || e(o, n));
  }, T = (o) => {
    e == null || e(o, "escapeKeyDown");
  };
  return /* @__PURE__ */ g(H, {
    ...r,
    ref: C,
    classes: {
      ...Q,
      ...r.classes
    },
    TransitionProps: {
      onExited: x,
      ...r.TransitionProps
    },
    fullScreen: s,
    onClose: S,
    $maximized: c && !s,
    children: [
      /* @__PURE__ */ g(J, {
        classes: W,
        children: [
          /* @__PURE__ */ t("span", {
            children: h
          }),
          /* @__PURE__ */ t(O, {
            children: y
          }),
          k(),
          u && /* @__PURE__ */ t(d, {
            "aria-label": "Close",
            onClick: T,
            size: "small",
            flavor: "plain",
            variant: "normal",
            children: /* @__PURE__ */ t($, {})
          }, "close")
        ]
      }),
      /* @__PURE__ */ t(U, {
        classes: G,
        children: i
      }),
      l && /* @__PURE__ */ t(V, {
        classes: q,
        children: z()
      })
    ]
  });
});
X.displayName = "Dialog";
export {
  X as default
};
